import { createSlice } from "@reduxjs/toolkit";

// Define the slice for category management
const categorySlice = createSlice({
    name: 'category', // Name of the slice
    initialState: {
        category: [], // Initial state with category set to an empty array
        savings: 0
    },
    reducers: {
        // Define the reducer to update the category state
        updateCategory(state, action) {
            state.category = action.payload; // Update the category state with the new payload
        },
        updateTotalSavings(state, action) {
            state.savings = action.payload
        }
    }
});

// Export the reducer to be included in the store
export default categorySlice.reducer;

// Export the action so it can be dispatched elsewhere
export const { updateCategory, updateTotalSavings } = categorySlice.actions;
